export const exportFile = (proxy: string | null, api: string, url: string, token: string | undefined, query?: string) => {
    const absoluteUrl: string = proxy ? proxy + api : api
    const fetchUrl = `${absoluteUrl}${url}?token=${token}&${query ?? ""}`
    const link = document.createElement('a');
    link.href = fetchUrl;
    document.body.appendChild(link);
    link.click()
}